module.exports = __webpack_public_path__ + "img/96jas_EN.3ce8bdda.jpg";